import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
// import { Link } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";

export default function TalktoLawyerForm() {
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    email: "",
    city: "",
  });

  const [errors, setErrors] = useState({});

  const Cities = [
    { id: "3294", name: "Abu Road" },
    { id: "3295", name: "Ajmer" },
    { id: "3296", name: "Aklera" },
    { id: "3297", name: "Alwar" },
    { id: "3298", name: "Amet" },
    { id: "3299", name: "Antah" },
    { id: "3300", name: "Anupgarh" },
    { id: "3301", name: "Asind" },
    { id: "3302", name: "Bagar" },
    { id: "3303", name: "Bagru" },
    { id: "3304", name: "Bahror" },
    { id: "3305", name: "Bakani" },
    { id: "3306", name: "Bali" },
    { id: "3307", name: "Balotra" },
    { id: "3308", name: "Bandikui" },
    { id: "3309", name: "Banswara" },
    { id: "3310", name: "Baran" },
    { id: "3311", name: "Bari" },
    { id: "3312", name: "Bari Sadri" },
    { id: "3313", name: "Barmer" },
    { id: "3314", name: "Basi" },
    { id: "3315", name: "Basni Belima" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "number" && value.length > 10) return;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleCityChange = (event, value) => {
    setFormData({ ...formData, city: value ? value.id : "" });
    setErrors({ ...errors, city: "" });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.number || formData.number.length !== 10)
      newErrors.number = "Valid phone number is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.city) newErrors.city = "City is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const response = await axios.post(
        "https://your-api-endpoint.com",
        formData
      );
      console.log("Success:", response.data);
      alert("Form submitted successfully!");
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to submit form.");
    }
  };

  return (
    <form className="was-validated AskfreeQuestionForm" onSubmit={handleSubmit}>
      <div className="row">
        <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
          <TextField
            fullWidth
            label="Your Name"
            size="small"
            name="name"
            value={formData.name}
            onChange={handleChange}
            error={!!errors.name}
            helperText={errors.name}
          />
        </div>
        <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
          <TextField
            fullWidth
            label="Your Phone Number"
            size="small"
            name="number"
            type="tel"
            inputMode="numeric"
            value={formData.number}
            onChange={handleChange}
            inputProps={{ maxLength: 10 }}
            error={!!errors.number}
            helperText={errors.number}
            InputProps={{
              startAdornment: <span style={{ marginRight: "5px" }}>+91</span>,
            }}
          />
        </div>
        <div className="form-group col-lg-6 col-md-6 col-sm-12 mb-3">
          <TextField
            fullWidth
            label="Your Email"
            size="small"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            error={!!errors.email}
            helperText={errors.email}
          />
        </div>
        <div className="form-group col-lg-6 col-md-12 col-sm-12 mb-3">
          <Autocomplete
            disablePortal
            options={Cities}
            getOptionLabel={(option) => option.name}
            sx={{ width: "100%" }}
            onChange={handleCityChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select your city"
                size="small"
                error={!!errors.city}
                helperText={errors.city}
              />
            )}
          />
        </div>
        <div className="form-group col-lg-12 col-md-6 col-sm-12 mb-3">
          <div className="input-group checkboxes square">
            <input type="checkbox" id="iagree" />
            <label htmlFor="iagree" className="remember verifycheckbx">
              <span className="custom-checkbox"></span> I agree to
            </label>
            <Link className="px-1">Term & Condition</Link>
          </div>
        </div>

        <div className="col-lg-12 col-md-12 text-center mt-2 mb-3">
          <button type="submit" className="theme-btn btn-style-three submitbtn">
            Submit
          </button>
        </div>
      </div>
    </form>
  );
}
